import algoliaSearch from "algoliasearch"
import {compact} from "lodash"

import {PRODUCTION} from "@irati/utils/constants/environment"
import {hasValidValues} from "@irati/geolocation/src/helpers/latLng"
import env from "@irati/utils/env"

import {AlgoliaPlace, LatLng} from "../types"

let places: any = null

interface SearchParam {
  query: string,
  countries?: string[],
  aroundLatLng?: string
}

const convertAlgoliaPlacesHitToLatLng = (hit: any): LatLng => {
  return {
    lat: hit._geoloc.lat,
    lng: hit._geoloc.lng
  }
}

export const getPlaceSuggestions = (query: string, centerLatLng: LatLng): Promise<AlgoliaPlace[]> => {
  if (!places) {
    const isProduction = env.ENVIRONMENT_NAME === PRODUCTION
    const PLACES_APP_ID = isProduction ? "plM2ADJDO5QQ" : "pl6N1KFFNQFW"
    const PLACES_API_KEY = isProduction ? "b26c88f521cf1558974104508d3e4ddc" : "94af8a6a000b101333fe1e466963abd3"
    // method is missing in definition file
    // @ts-ignore
    places = algoliaSearch.initPlaces(PLACES_APP_ID, PLACES_API_KEY)
  }

  const searchParams: SearchParam = {
    query
  }

  if (centerLatLng && hasValidValues(centerLatLng.lat, centerLatLng.lng)) {
    searchParams.aroundLatLng = `${centerLatLng.lat}, ${centerLatLng.lng}`
  }

  return places.search(searchParams).then((results: algoliaSearch.Response) =>
    results.hits.map((hit: any) => {
      const {locale_names, county, postcode, country} = hit
      const part1 = locale_names ? locale_names.default.join(", ") : ""
      const part2 = county ? county.default.join(", ") : ""
      const part3 = postcode && Array.isArray(postcode) && postcode.length === 1 ? postcode[0] : ""
      const part4 = country ? country.default : ""
      const desc = compact([part1, part2, part3, part4]).join(", ")
      const latLng = convertAlgoliaPlacesHitToLatLng(hit)
      return Object.assign({desc}, latLng)
    })
  )
}
